history.scrollRestoration = "manual";

import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from "pinia";
import router from './router';
import i18n from './i18n';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'vant/lib/index.css';
import './styles/global.scss';
import 'vant/es/toast/style';
import longpress from "./directives/longpress";

const app = createApp(App);
const pinia = createPinia();
app.directive("longpress", longpress); //长按
app.use(router);
app.use(pinia);
app.use(i18n);
app.use(ElementPlus);
app.mount('#app');
